define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var VisitorFeedApi = require('web-agent-assets-js/visitorFeedBearer');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var VisitorFeedSimulator = require('web-agent-mocks/VisitorFeedSimulator');

    window.lpTag = window.lpTag || {};
    lpTag.lpVisitorFeedController = function (model) {
        var visitorFeedController = {applicationType: "lpVisitorFeedController"};
        var logger = WebAgentLogger.getLogger(visitorFeedController.applicationType);
        var visitorFeedApi;
        var startPolling = false;
        var visitorsInfoQueue = {};
        var visitorsInfoPollingTimeout = null;
        var visitorInfoPollingTime = 20000;
        var useSimulator = false;
        //    useSimulator = true;
        var firstTimeUse = false;
        var agentGroupNameList = {};
        visitorFeedController.DEFULT_VISITORS_PAGE_SIZE = 50;

        if (agentLEManager.isFirstTimeLELogin() && !useSimulator && !LE.siteSettings.customizationSettings.isHideLeTagPage()) {
            useSimulator = true;
            firstTimeUse = true;
            agentLEManager.onceLEEvent("TagFlowBanner:onClose", stopSimulator, this);
        }

        function stopSimulator() {
            visitorFeedController.setUseSimulator({useSimulator: false});
        }

        var sortTagMap = {
            sort: "filterName",
            state: "state-timestamp",
            agentNickName: "agent-nick-name",
            visitStartTime: "start-time",
            sentimentScore: "sentiment"
        };

        var queryData = {
            limit: visitorFeedController.DEFULT_VISITORS_PAGE_SIZE,
            skip: 0,
            includeCount: true
        };

        // Temporary fix to support both versions of visitor feed API
        if (lpTag.WebAgent.logicController.hasVisitorFeedQueryFeature()) {
            queryData.sort = "state:asc";
        } else {
            queryData[sortTagMap.sort] = sortTagMap.state;
            queryData.descending = false;
        }

        var defaultSearchUIData = {
            limit: queryData.limit,
            skip: queryData.skip,
            includeCount: queryData.includeCount,
            sortTag: "state",
            sortOrder: "asc"
        };

        visitorFeedController.setUseSimulator = function (options) {
            logger.info("", "setUseSimulator", options);
            var restart = false;
            if (options) {
                if (typeof options.useSimulator !== 'undefined' && options.useSimulator != useSimulator) {
                    useSimulator = options.useSimulator;
                    restart = true;
                }
                if (typeof options.firstTimeUse !== 'undefined' && options.firstTimeUse != firstTimeUse) {
                    firstTimeUse = options.firstTimeUse;
                    if (useSimulator) {
                        restart = true;
                    }
                }
                if (restart) {
                    // end the old feed (startPolling calls clearPollingData - but only on success, so there could be a delay)
                    visitorFeedApi.clearPollingData();
                    model.set("participants.visitorList.state", { status: "fetching", success: "ok", unloaded: "ok" });
                    startPolling = true;
                    // start the new feed
                    visitorFeedApi = null;
                    initVisitorFeedApi();
                }
            }
        };

        visitorFeedController.startPolling = function () {
            logger.info("", "startPolling");
            if (visitorFeedApi) {
                visitorFeedApi.startPolling();
                startPolling = true;
                model.set("participants.visitorList.state", { status: "fetching", success: "ok" });
            }
        };

        visitorFeedController.stopPolling = function () {
            logger.info("", "stopPolling");
            if (visitorFeedApi) {
                visitorFeedController.visitorListLoaded = false;
                visitorFeedApi.stopPolling();
                startPolling = false;
            }
        };

        visitorFeedController.updateQuery = function (data) {
            updateQuery(data);
            getVisitors();
        };

        visitorFeedController.getSpecificPage = function (data) {
            visitorFeedController.updateQuery({skip: (data - 1) * queryData.limit, includeCount: true});
        };

        visitorFeedController.saveSessionData = function (data) {
            saveSessionData(data);
        };

        visitorFeedController.getSessionData = function (data) {
            return getSessionData(data);
        };

        visitorFeedController.removeSessionData = function (data) {
            removeSessionData(data);
        };

        visitorFeedController.getModelParam = function (paramName) {
            return model.get(paramName);
        };

        visitorFeedController.bindModelParam = function (modelParam, func, scope) {
            model.bind(modelParam, func, scope);
        };

        visitorFeedController.unbindModelParam = function (key, callback, context) {
            model.unbind(key, callback, context);
        };

        function initVisitorFeedApi() {
            var savedQuery = getSessionData({name: visitorFeedController.applicationType, key: "lastQuery"});
            if (typeof(savedQuery) === "undefined" || savedQuery === null || savedQuery === "") {
                savedQuery = defaultSearchUIData;
            }

            updateQuery(savedQuery);
            var requestData = createRequestDataObject();
            var pollingData = {
                accessToken: agentLEManager.getGlobLE(),
                lpNumber: model.get('account'),
                startPolling: startPolling,
                firstTimeUse: firstTimeUse,
                pollingTimeout: getVisitorFeedPollingTimeout(),
                query: requestData.queryData,
                data: requestData.bodyData
            };
            if (!visitorFeedApi) {
                if (useSimulator) {
                    visitorFeedApi = new VisitorFeedSimulator.VisitorFeedSimulatedApi(pollingData);
                } else {
                    visitorFeedApi = new VisitorFeedApi(pollingData);
                }
                bindVisitorFeedApiCallbacks();
            }

            startVisitorInfoPolling();
        }

        function init() {
            initVisitorFeedApi();

            if (lpAgent.agent) {
                lpAgent.agent.onLogOutAgent(handleLoginStateChanged);
            }

            agentGroupNameList = lpTag.WebAgent.logicController.getAgentGroupsById();
        }

        function handleLoginStateChanged(data) {
            if (data) {
                switch (data.status) {
                    case    "loggedOff" :
                        stopVisitorsInfoPolling();
                        visitorFeedApi.clearPollingData();
                        break;
                    default : break;
                }
            }
        }

        function bindVisitorFeedApiCallbacks() {
            for (var key in visitorFeedApi) {
                if (visitorFeedApi.hasOwnProperty(key)) {
                    if (String(key).indexOf('on') === 0) {
                        switch (key) {
                            case "onVisitorList"  :
                                visitorFeedApi.onVisitorList(handleVisitorList);
                                break;
                            case "onVisitorsInfo" :
                                visitorFeedApi.onVisitorsInfo(handleVisitorsInfo);
                                break;
                            default               :
                                visitorFeedApi[key](handleErrors);
                                break;
                        }
                    }
                }
            }
        }

        function createRequestDataObject() {
            var data = model.get("participants.visitorList.lastQuery");
            var queryData = {}, bodyData = {};

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    switch (key) {
                        case    "sortOrder" :
                            if (!lpTag.WebAgent.logicController.hasVisitorFeedQueryFeature()) {
                                queryData.descending = data[key] === "desc"; break;
                            }
                            break;
                        case    "sortTag" :
                            if (lpTag.WebAgent.logicController.hasVisitorFeedQueryFeature()) {
                                queryData.sort = data[key];
                                if (data.sortOrder) {
                                    queryData.sort += ":" + data.sortOrder;
                                }
                            } else {
                                queryData[sortTagMap.sort] = sortTagMap[data[key]] || data[key];
                            }
                            break;
                        case    "skillIds":
                            bodyData.skill = data[key] ? data[key].split(",").map(fixUnassignedValue) : null; break;
                        case    "agentIds":
                            bodyData.agentId = data[key] ? data[key].split(",").map(parseStringToInt) : null; break;
                        default :
                            queryData[key] = data[key];
                    }
                }
            }

            return {
                queryData: queryData,
                bodyData: bodyData
            };

            function parseStringToInt(num) {return parseInt(num, 10);}
            function fixUnassignedValue(skill) { return skill === agentLEManager.translateLE('LEWebAgent.unassigned') ? "" : skill;}
        }

        function updateQuery(searchData) {
            for (var item in searchData) {
                if (typeof searchData[item] === 'undefined') {
                    model.removeKey("participants.visitorList.lastQuery." + item);
                }
            }
            model.modify("participants.visitorList.lastQuery", searchData);
            var lastQuery = model.get("participants.visitorList.lastQuery");
            saveSessionData({name: visitorFeedController.applicationType, key: "lastQuery", value: lastQuery});
        }

        function getVisitors() {
            if (visitorFeedApi) {
                // creating the data based on the last query information.
                var dataObject = createRequestDataObject();

                visitorFeedApi.updateQuery(dataObject.queryData);
                visitorFeedApi.updateBodyData(dataObject.bodyData);
                visitorFeedApi.startPolling();
                model.set("participants.visitorList.state", { status: "fetching", success: "ok" });
            }
        }

        function handleVisitorList(data) {
            var visitorsObject = getVisitorsObject(data);
            if (lpTag.WebAgent.logicController.hasVisitorFeedPreFiltering()) {
                handleVisitorListCountPreFiltering(data.visitorsList);
            } else {
                handleVisitorListCount(data);
            }

            if (visitorsObject) {
                visitorFeedController.visitorListLoaded = true;
                pagesObjectHandler(visitorsObject);
                model.set("participants.visitorList.data", visitorsObject);
                model.set("participants.visitorList.array", data.visitorsList.visitors);
                model.set("participants.visitorList.state", { status: "fetched", success: "ok", itemsCount: data.visitorsList.visitors.length});
            }
        }

        function handleVisitorListCount(data) {
            if (data.visitorsList && data.visitorsList.count) {
                model.set("participants.visitorList.count", data.visitorsList.count);
                if (data.visitorsList.count > 0) {
                    agentLEManager.triggerLEEvent("webAgent:hasVisitors");
                }
            }
        }

        function handleVisitorListCountPreFiltering(data) {
            if (data.count) {
                model.modify("participants.visitorList.currIndex", data.currIndex);
                model.modify("participants.visitorList.nextIndex", data.nextIndex);
                model.modify("participants.visitorList.prevIndex", data.prevIndex);
                model.set("participants.visitorList.count", data.count);
                if (data.count > 0) {
                    agentLEManager.triggerLEEvent("webAgent:hasVisitors");
                }
            }
        }

        function pagesObjectHandler(data) {
            _.forEach(data, function (visitor) {
                visitor.participantInfo.pages = _.uniq(visitor.participantInfo.pages, true, function (item) {
                    return item.pageUrl;
                });
                if (visitor.participantInfo.pages.length > 0) {
                    visitor.participantInfo.currentPage = {
                        url: visitor.participantInfo.pages[0].pageUrl,
                        title: visitor.participantInfo.pages[0].pageTitle,
                        startTime: visitor.participantInfo.pages[0].pageLastAccessTime
                    };
                }
                visitor.participantInfo.pageCount = visitor.participantInfo.pages.length;
                visitor.participantInfo.pages = null;
                delete visitor.participantInfo.pages;
            });
        }

        function handleVisitorsInfo(data) {
            var visitorsObject = getVisitorsObject(data);
            if (visitorsObject) {
                for (var visitorId in visitorsObject) {
                    if (visitorsObject.hasOwnProperty(visitorId)) {
                        var participantInfo = visitorsObject[visitorId].participantInfo;
                        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                        if (model.get(participantPath) !== null) {
                            // TODO: currently the only way to identify this data belongs to a shark visitor is the fact that the id is a not a number,
                            // TODO: later we will get a more solid way to identify this from the VF service and we should update the code accordingly.
                            if (isNaN(participantInfo.id)) {
                                participantInfo = participantInfoManipulation(participantInfo);// made in order to prevent double IP on the UI (LE-9194)
                                for (var prop in participantInfo) { // Adding all other data on the participant to the model
                                    if (participantInfo.hasOwnProperty(prop)) {
                                        if (participantInfo[prop].constructor !== Array) {
                                            model.modify(participantPath + ".participantInfo." + prop, participantInfo[prop]);
                                        }
                                    }
                                }
                            } else {
                                model.modify(participantPath + ".participantInfo.sentimentScore", participantInfo.sentimentScore);
                            }
                        }
                    }
                }
            }
            visitorsObject = null;
        }

        function participantInfoManipulation(participantInfo) {
            if (participantInfo.ipAddress) {
                participantInfo.ip = participantInfo.ipAddress;
                delete participantInfo.ipAddress;
            }
            if (participantInfo.customVariables) { // removing custom variables
                participantInfo.customVariables = null;
                delete participantInfo.customVariables;
            }
            if (participantInfo.pages) { // removing pages
                participantInfo.pages = null;
                delete participantInfo.pages;
            }
            return participantInfo;
        }

        function getVisitorsObject(data) {
            var visitorObject = null;
            handleErrors(data);
            if (data.visitorsList && data.visitorsList.visitors) {
                modifyVisitorsArray(data.visitorsList.visitors);
                visitorObject = convertVisitorsArray(data.visitorsList.visitors);
                visitorObject = addMissingAgentInfo(visitorObject);

            }
            return visitorObject;
        }

        function handleErrors(data) {
            if (data && data.error) {
                notifyError(data);
            }
        }

        function modifyVisitorsArray(visitorsArray) {
            if (visitorsArray) {
                for (var i = 0; i < visitorsArray.length; i++) {
                    if (visitorsArray[i].pages) {
                        visitorsArray[i].pages = visitorsArray[i].pages.reverse();
                    }
                    if (visitorsArray[i].agentId) {
                        visitorsArray[i].displayName = getNameById(visitorsArray[i].agentId.fieldValue, model.get("operators.data"), "displayName", "unassigned");
                    }
                    if (visitorsArray[i].agentGroupId) {
                        visitorsArray[i].agentGroupName = agentGroupNameList[visitorsArray[i].agentGroupId.fieldValue] ? agentGroupNameList[visitorsArray[i].agentGroupId.fieldValue] : "";
                    }
                    if (visitorsArray[i].customVariables) {
                        visitorsArray[i].customVariables = null;
                        delete visitorsArray[i].customVariables;
                    }
                }
            }
        }

        function getNameById(id, nameMap, key, textPlaceholder) {
            var name = '';
            if (nameMap && id && nameMap.hasOwnProperty(id) && nameMap[id][key]) {
                name = nameMap[id][key];
            } else if (privilegesController.hasAgentManagerModulePrivilege()) {
                name = agentLEManager.translateLE('LEWebAgent.' + textPlaceholder);
            }
            return name;
        }

        function notifyError(data) {
            model.set("participants.visitorList.data", {});
            model.set("participants.visitorList.state", { status: "error", error: {message: data.error.message || (data.error.body && data.error.body.message) || data.error}});
        }

        function convertVisitorsArray(visitorsArray) {
            if (!visitorsArray) {
                return;
            }
            var visitorsObject = {};
            for (var i=0; i<visitorsArray.length; i++) {
                visitorsArray[i] = convertVisitorObject(visitorsArray[i]);
                visitorsObject[visitorsArray[i].participantInfo.id] = visitorsArray[i];
            }
            return visitorsObject;
        }

        function addMissingAgentInfo(visitorsObject) {
            var visitorObject;
            for(var key in visitorsObject) {
                visitorObject = visitorsObject[key].participantInfo;
                var chatId = visitorObject.rtSessionId;
                var chatInfo = model.get("chats." + chatId);
                var agentInfo = chatInfo && chatInfo.agentInfo;

                if (agentInfo) {
                    visitorObject.displayName = visitorObject.displayName || agentInfo.agentName;
                    visitorObject.agentId = visitorObject.agentId || agentInfo.agentId;
                }
            }
            return visitorsObject;
        }

        function convertVisitorObject(visitorObject) {
            var convertedObject = {};
            if (visitorObject) {
                for (var property in visitorObject) {
                    if (visitorObject[property].constructor === Array) {
                        convertedObject[property] = visitorObject[property];
                    } else {
                        convertedObject[property] = typeof visitorObject[property].fieldValue !== "undefined" ? visitorObject[property].fieldValue : visitorObject[property];
                    }
                }
            }
            return {participantInfo: convertedObject};
        }

        function handleNewParticipant(data) {
            for (var visitorId in data.newValue) {
                if (data.newValue.hasOwnProperty(visitorId) && !lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId)) {
                    var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                    model.bind(participantPath + ".chats", addVisitorToInfoQueue);
                    model.bind(participantPath, handleVisitorDisposed);
                }
            }
        }

        function addVisitorToInfoQueue(data) {
            var visitorId = data.key.split('.')[2];
            var chatId;
            var chatIds = Object.keys(data.newValue);
            for (var chat in chatIds) {
                chatId = chatIds[chat];
                visitorFeedApi.getVisitorsInfo({vid: [visitorId]});
                if (visitorsInfoQueue && !visitorsInfoQueue[visitorId]) {
                    visitorsInfoQueue[visitorId] = visitorId;
                    model.bind("chats." + chatId + ".chatInfo.state", handleChatStateChanged);
                }
                if (lpUtils.objectKeysCount(visitorsInfoQueue) > 0) {
                    scheduleVisitorsInfoPolling();
                }
            }
        }

        function handleChatStateChanged(data) {
            var chatId = data.key.split('.')[1];
            var visitorId = model.get("chats." + chatId + ".visitorInfo.visitorId");
            var state = data.newValue;
            if (state === 'ended' || state === 'transferred') {
                removeVisitorFromInfoQueue(visitorId);
                model.unbind("chats." + chatId + ".chatInfo.state", handleChatStateChanged);
            }
        }

        function removeVisitorFromInfoQueue(visitorId) {
            if (visitorsInfoQueue && visitorsInfoQueue[visitorId]) {
                visitorsInfoQueue[visitorId] = null;
                delete visitorsInfoQueue[visitorId];
            }
        }

        function handleVisitorDisposed(data) {
            if (data && data.removedValue) {
                var visitorId = data.removedValue.participantInfo.id || data.removedValue.participantInfo.visitorId;
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
                model.unbind(participantPath + ".chats", addVisitorToInfoQueue);
                model.unbind(participantPath, handleVisitorDisposed);
            }
        }

        function scheduleVisitorsInfoPolling() {
            if (visitorsInfoPollingTimeout) {
                clearTimeout(visitorsInfoPollingTimeout);
            }
            visitorsInfoPollingTimeout = setTimeout(getVisitorsInfo, visitorInfoPollingTime);
        }

        function startVisitorInfoPolling() {
            model.bind("participants.myEngagements", handleNewParticipant);
        }

        function stopVisitorsInfoPolling() {
            model.unbind("participants.myEngagements", handleNewParticipant);
            if (visitorsInfoPollingTimeout) {
                clearTimeout(visitorsInfoPollingTimeout);
                visitorsInfoPollingTimeout = null;
            }
        }

        function getVisitorsInfo() {
            var vidArray = lpUtils.objectKeysArray(visitorsInfoQueue);
            if (vidArray.length > 0) {
                visitorFeedApi.getVisitorsInfo({vid: vidArray});
                scheduleVisitorsInfoPolling();
            }
            vidArray = null;
        }

        function saveSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.setSessionData(visitorFeedController.applicationType + '_' + data.name, data.key, data.value);
            }
        }

        function getSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                return lpTag.WebAgent.WebAgentSessionStorage.getSessionData(visitorFeedController.applicationType + '_' + data.name, data.key);
            }
        }

        function removeSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.removeSessionData(visitorFeedController.applicationType + '_' + data.name, data.key);
            }
        }

        function getVisitorFeedPollingTimeout() {
            var DEFAULT_POLLING_TIME = 15000; // 15Sec
            return lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings("le.agent.visitorlist.refreshRate", DEFAULT_POLLING_TIME);
        }

        init();
        return visitorFeedController;
    };

    return lpTag.lpVisitorFeedController;

});
